import React from "react";

import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";

import FontAwesomeIcon from "components/FontAwesomeIcon";

type Props = {
  items: any;
  onRemove: any;
};

// TODO: revamp
const Chips = ({ items, onRemove }: Props) => {
  return (
    <div className="max-h-[175px] md:h-[175px] overflow-y-scroll">
      <div className="mt-[10px] flex align-baseline flex-wrap">
        {items.map((item: any) => (
          <div
            key={item}
            className="bg-utah-sky text-white m-[5px] px-[15px] py-[5px] rounded-full"
          >
            {item}
            <FontAwesomeIcon
              onClick={() => {
                onRemove(item);
              }}
              icon={faTimes}
              className="ml-[5px] cursor-pointer"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Chips;
